module.exports = __webpack_public_path__ + "static/clouds-left-1b414ca2ec0e1b765f4ac62da63d2645.png";